/* eslint-disable @typescript-eslint/no-explicit-any */

export class EventDispatcher {
  private listeners = new Map<string, ((...args: any[]) => void)[]>();

  /**
   * Call all handlers registered for `event`, in registration order.
   */
  public dispatchEvent(event: string, ...args: any[]): void {
    const handlers = this.listeners.get(event);
    if (!handlers) return;
    for (const handler of handlers) {
      handler.apply(this, args);
    }
  }

  /**
   * Register `handler` to be called whenever `event` is dispatched.
   */
  public on(event: string, handler: (...args: any[]) => void): void {
    const handlers = this.listeners.get(event);
    if (handlers) {
      handlers.push(handler);
    } else {
      this.listeners.set(event, [handler]);
    }
  }

  /**
   * Unregister `handler` from `event`.
   */
  public off(event: string, handler: (...args: any[]) => void): void {
    const handlers = this.listeners.get(event);
    if (!handlers) return;

    const idx = handlers.indexOf(handler);
    if (idx !== -1) {
      handlers.splice(idx, 1);
      // optional: clean up empty listener arrays
      if (handlers.length === 0) {
        this.listeners.delete(event);
      }
    }
  }
}
